<template>

	<Head title="Welcome" />

	<v-row class="justify-center">
		<v-col cols="12" class="pa-0">
			<div class="min-h-[90vh] align-content-center welcome-header">
				<span>
					<h1
						class="text-center text-6xl font-bold drop-shadow-[1px_1px_2px_black] text-transparent bg-clip-text bg-gradient-to-t from-orange-800/50 via-amber-100/80 to-transparent">
						🏘 Rensar Enterprise
					</h1>
					<h1
						class="text-center text-6xl font-bold drop-shadow-[1px_1px_2px_black] text-transparent bg-clip-text bg-gradient-to-t from-orange-800/50 via-transparent to-transparent reflection">
						🏘 Rensar Enterprise
					</h1>
				</span>
				<div class="backdrop-blur backdrop-opacity-70 bg-white-700/60 shadow-2xl -mt-10">
					<p class="text-center typing-text text-ellipsis text-nowrap skew-x-12">
						<span id="typed" class="font-mono"></span>
					</p>
				</div>
			</div>
			<span v-if="systemSettings['show developer info on homepage']">
				<v-chip class="designer lime darken-1" role="button" size="x-large" @click="devInfo = !devInfo"
					id="designer-chip">
					<v-card>
						<v-card-text class="">
							<p class="my-0 black--text">Designed and Maintained By:</p>
							<p class="my-0">
								<v-icon>mdi-phone-classic</v-icon>
								<a :href="`tel:+${systemSettings['developer phone number']}`" class="pull-right black--text">{{
									systemSettings['developer name'] }}</a>
							</p>
						</v-card-text>
					</v-card>
					<v-tooltip location="top" color="transparent" content-class="custom-tooltip-with-arrow" v-model="devTooltip"
						activator="parent" target="#designer-chip">
						<span>Click here for developer contact info.</span>
					</v-tooltip>
				</v-chip>
				<v-menu open-on-hover :close-delay="2500" absolute top transition="scale-transition" origin="bottom left"
					v-model="devInfo" target="#designer-chip">
					<v-list two-line dense class="rounded-lg shadow-lg border-green-600">
						<v-list-item :href="`tel:+${systemSettings['developer phone number']}`" target="_blank"
							prepend-icon="mdi-phone-classic" title="Phone"
							:subtitle="`+${systemSettings['developer phone number']}`" />
						<v-list-item :href="`https://x.com/${systemSettings['developer X username']}`" target="_blank"
							prepend-icon="mdi-twitter" title="Twitter" :subtitle="`@${systemSettings['developer X username']}`" />
						<v-list-item :href="`https://linkedin.com/in/${systemSettings['developer LinkedIn username']}`"
							target="_blank" prepend-icon="mdi-linkedin" title="LinkedIn"
							:subtitle="`${systemSettings['developer LinkedIn username']}`" />
						<v-list-item :href="`https://gitlab.com/${systemSettings['developer Gitlab username']}`" target="_blank"
							prepend-icon="mdi-gitlab" title="Gitlab" :subtitle="`${systemSettings['developer Gitlab username']}`" />
						<v-list-item :href="`https://github.com/${systemSettings['developer GitHub username']}`" target="_blank"
							prepend-icon="mdi-github" title="GitHub" :subtitle="`${systemSettings['developer GitHub username']}`" />
					</v-list>
				</v-menu>
			</span>
		</v-col>
	</v-row>

</template>

<script setup>
	import AppLayout from '@/Layouts/Guest.vue'
	import { onMounted, ref } from 'vue'
	import Typed from 'typed.js'

	defineOptions({
		layout: AppLayout,
		name: 'Title',
	})

	const devInfo = ref(false)

	const devTooltip = ref(true)

	const introText = ref([
		'Manage multiple properties.',
		'Rent collection for all your units.',
		'Add charges on top of rent.',
		'And much more...',
		'🏠 💷',
	])

	function mounted() {
		new Typed('#typed', {
			strings: introText.value,
			typeSpeed: 50,
			shuffle: false,
			loop: true,
			startDelay: 200,
			smartBackspace: false,
			// cursorChar: '_',
			backDelay: 2000,
			backSpeed: 10,
		})
	}

	onMounted(() => {
		mounted()
	})

</script>

<style scoped>
	.welcome-header {
		background-image: linear-gradient(to top right, rgba(255, 0, 0, 0.225), rgba(0, 45, 128, 0.716)), url('https://picsum.photos/2000/800');
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
	}

	.typing-text {
		font-size: 1.5rem;
		background-image: linear-gradient(rgba(181, 179, 179, 0.206), rgba(186, 198, 50, 0.532)), url('https://picsum.photos/2000/300/?blur');
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
		background-clip: text;
		color: transparent;
	}

	.reflection {
		transform: rotatex(180deg) translatey(6px);
	}

	.designer {
		position: fixed;
		left: 1px;
		bottom: 72px;
		width: fit-content;
	}

</style>
